export default "__VITE_ASSET__BeFSFspX__"